import { defineStore } from 'pinia';
import { useFeatureListStore } from './feature-list';
export const useDesignerPlanStore = defineStore('designer-plan', {
    getters: {
        designMap() {
            const featureList = useFeatureListStore();
            const resultMap = new Map();
            featureList.data?.category_list.forEach((categoryItem) => {
                categoryItem.sub_category_list.forEach((subCategoryItem) => {
                    if (subCategoryItem.designer_plan_desc) {
                        resultMap.set(subCategoryItem.code, subCategoryItem);
                    }
                });
            });
            console.log('[designer]: resultMap=', resultMap, featureList);
            return resultMap;
        },
    },
});
